import { PaymentsWorkspace } from '@/components/payments/payments-workspace'

export function CommitteePayments() {
  return <PaymentsWorkspace billingPath="/committee/billing" />
}
